import React, { useEffect, useState } from 'react';

import { PageHeader } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getOcppTag, getOcppTagsCards } from '../../hooks/ocpptags';
import { getTenants } from '../../hooks/tenants';
import { getUsersDashboard } from '../../hooks/users';
import OcppTagForm from '../organisms/OcppTagForm';
import { ListSkeleton } from '../molecules/ListSkeleton/ListSkeleton';

const OcppTagsEditPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const OcppTagsEditPageWrapperLoading = styled(OcppTagsEditPageWrapper)`
  width: 100%;
`;

const Error = () => (
  <OcppTagsEditPageWrapper>
    <p>Nenhum Ocpp Tag encontrado com este id.</p>
  </OcppTagsEditPageWrapper>
);

const OcppTagsEditPage = () => {
  const { id } = useParams();

  const [ocppTag, setOcppTag] = useState(null);
  const [ocppTags, setOcppTags] = useState({});
  const [usersList, setUsersList] = useState({});
  const [tenants, setTenants] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      setOcppTag(await getOcppTag(id));
      if (!Object.keys(ocppTags).length) setOcppTags(await getOcppTagsCards('USER'));
      if (!Object.keys(usersList).length) {
        try {
          const { userDashboardList } = await getUsersDashboard(true, 1, 30000);

          setUsersList(userDashboardList);
        } catch (error) {
          setUsersList(null);
        }
      }
      if (!Object.keys(tenants).length) setTenants(await getTenants());

      setLoading(false);
    })();
  }, [id]);

  if (ocppTag === null || !usersList?.length || !ocppTags?.ocppTagList?.length) {
    if (loading) {
      return (
        <OcppTagsEditPageWrapperLoading>
          <PageHeader className='site-page-header' onBack={() => history.goBack()} title={T('Editing OCPP Tag')} />

          <ListSkeleton />
        </OcppTagsEditPageWrapperLoading>
      );
    } else {
      return (
        <OcppTagsEditPageWrapperLoading>
          <PageHeader className='site-page-header' onBack={() => history.goBack()} title={T('Editing OCPP Tag')} />

          <Error />
        </OcppTagsEditPageWrapperLoading>
      );
    }
  }

  if (ocppTag?.error) return <Error />;

  const {
    ocppTagPk,
    idTag,
    note,
    ownerUserPk,
    parentUserPk,
    parentIdTag,
    tenantPk,
    type,
    inactive,
    parentUserName,
    isFreeRecharge,
  } = ocppTag.ocppTag;

  const initialValues = {
    ...ocppTag.ocppTag,
    ocpp_tag_pk: ocppTagPk,
    id_tag: idTag,
    note: note,
    owner_user_pk: ownerUserPk,
    parent_user_pk: parentUserPk,
    parent_id_tag: parentIdTag && `${parentIdTag} - (${parentUserName})`,
    tenant_pk: tenantPk,
    type: type,
    inactive: inactive,
    parent_user_name: parentUserName,
    isFreeRecharge: isFreeRecharge,
  };

  return (
    <OcppTagsEditPageWrapper>
      <PageHeader className='site-page-header' onBack={() => history.goBack()} title={T('Editing OCPP Tag')} />
      <OcppTagForm
        initialValues={initialValues}
        loading={loading}
        ocppTagPk={id}
        ocppTags={ocppTags}
        usersList={usersList}
        tenants={tenants}
        type='update'
      />
    </OcppTagsEditPageWrapper>
  );
};

export default OcppTagsEditPage;
